import { render, staticRenderFns } from "./DemoMessage.vue?vue&type=template&id=18e9d672&scoped=true&"
import script from "./DemoMessage.vue?vue&type=script&lang=js&"
export * from "./DemoMessage.vue?vue&type=script&lang=js&"
import style0 from "./DemoMessage.vue?vue&type=style&index=0&id=18e9d672&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e9d672",
  null
  
)

/* custom blocks */
import block0 from "./DemoMessage.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports